/**
 * Querysleutels van het team. Instellingen en de inspecteurskeuze lezen dezelfde
 * lijsten, dus een uitnodiging of een nieuwe rol ververst ze allebei.
 */
export const teamKeys = {
    all: ['tenant', 'team'] as const,
    members: () => ['tenant', 'team', 'members'] as const,
    activeMembers: () => ['tenant', 'team', 'members', 'active'] as const,
    invitations: () => ['tenant', 'team', 'invitations'] as const,
};
